import type { SearchResult } from '@rover/types/src/apiResponses/FetchSearchResponse';

const getSitterLocation = (
  isFacility: boolean,
  businessAddress: SearchResult['businessAddress'],
  neighborhood: SearchResult['neighborhood'],
  city: SearchResult['city'],
  state: SearchResult['state'],
  zip: SearchResult['zip']
): string => {
  const serviceLocation = [neighborhood, city, state, zip].filter(Boolean).join(', ');
  const facilityLocation = businessAddress;
  return isFacility && facilityLocation ? facilityLocation : serviceLocation;
};

export default getSitterLocation;
